export const CalendarCheckIcon = () => (
  <svg
    width="100"
    height="40"
    viewBox="0 0 130 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M84.0094 70H28.2075C25.8369 70 23.9151 68.8343 23.9151 67.3963C23.9151 65.9583 25.8369 64.7926 28.2075 64.7926H4.29245C1.9218 64.7926 0 63.6269 0 62.189C0 60.751 1.9218 59.5853 4.29245 59.5853H28.8208C31.1914 59.5853 33.1132 58.4196 33.1132 56.9817C33.1132 55.5437 31.1914 54.378 28.8208 54.378H13.4906C11.1199 54.378 9.19811 53.2123 9.19811 51.7744C9.19811 50.3364 11.1199 49.1707 13.4906 49.1707H38.0189C35.6482 49.1707 33.7264 48.005 33.7264 46.567C33.7264 45.1291 35.6482 43.9634 38.0189 43.9634H72.9717C75.3424 43.9634 77.2641 45.1291 77.2641 46.567C77.2641 48.005 75.3424 49.1707 72.9717 49.1707H112.217C114.588 49.1707 116.509 50.3364 116.509 51.7744C116.509 53.2123 114.588 54.378 112.217 54.378H125.708C128.078 54.378 130 55.5437 130 56.9817C130 58.4196 128.078 59.5853 125.708 59.5853H114.057C111.686 59.5853 109.764 60.751 109.764 62.189C109.764 63.6269 111.686 64.7926 114.057 64.7926H117.736C120.106 64.7926 122.028 65.9583 122.028 67.3963C122.028 68.8343 120.106 70 117.736 70H85.8491C85.5333 70 85.2256 69.9793 84.9292 69.94C84.6329 69.9793 84.3252 70 84.0094 70Z"
      fill="#F3F7FF"
    />
    <g clipPath="url(#clip0_11852_27643)">
      <mask
        id="mask0_11852_27643"
        maskUnits="userSpaceOnUse"
        x="38"
        y="-1"
        width="66"
        height="66"
      >
        <path
          d="M103.063 63.9581V0.0653648H38.1947V63.9581H103.063Z"
          fill="white"
          stroke="white"
          strokeWidth="0.131602"
        />
      </mask>
      <g mask="url(#mask0_11852_27643)">
        <path
          d="M65.3779 17.0127H39.0859V10.8802C39.0859 8.50183 41.0582 6.55584 43.4728 6.55584H45.4737M89.5969 6.55584H91.5944C94.009 6.55584 95.9848 8.50183 95.9848 10.8802V17.0127H69.6927M76.3539 6.55584H85.1958M63.1144 6.55584H71.9563M49.8711 6.55584H58.7131"
          stroke="#009045"
          strokeWidth="1.97337"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M95.9847 24.899V39.6376M95.9847 17.0121V20.6525M39.0859 45.6422V17.0121M78.4373 55.6489H43.0841C40.8852 55.6489 39.0859 53.8766 39.0859 51.7107V49.8887"
          stroke="#009045"
          strokeWidth="1.97337"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M74.154 1.41914C75.3631 1.41914 76.3529 2.39388 76.3529 3.58496V9.4762C76.3529 10.6672 75.3631 11.642 74.154 11.642C72.9449 11.642 71.9553 10.6672 71.9553 9.4762V3.58496C71.9553 2.39388 72.9449 1.41914 74.154 1.41914ZM60.9146 1.41914C62.1237 1.41914 63.1133 2.39388 63.1133 3.58496V9.4762C63.1133 10.6672 62.1237 11.642 60.9146 11.642C59.7018 11.642 58.7121 10.6672 58.7121 9.4762V3.58496C58.7121 2.39388 59.7018 1.41914 60.9146 1.41914ZM47.6714 1.41914C48.8806 1.41914 49.8702 2.39388 49.8702 3.58496V9.4762C49.8702 10.6672 48.8806 11.642 47.6714 11.642C46.4623 11.642 45.4727 10.6672 45.4727 9.4762V3.58496C45.4727 2.39388 46.4623 1.41914 47.6714 1.41914ZM87.3972 1.44402C88.6064 1.44402 89.596 2.41877 89.596 3.60984V9.50108C89.596 10.6919 88.6064 11.6704 87.3972 11.6704C86.1845 11.6704 85.1948 10.6919 85.1948 9.50108V3.60984C85.1948 2.41877 86.1845 1.44402 87.3972 1.44402Z"
          stroke="#009045"
          strokeWidth="1.97337"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.0273 33.9385H56.2732V22.8649H45.0273V33.9385Z"
          stroke="#009045"
          strokeWidth="1.97337"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.0273 49.793H56.2732V38.7195H45.0273V49.793Z"
          fill="white"
          stroke="#009045"
          strokeWidth="1.97337"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M61.9141 33.9385H73.1564V22.8649H61.9141V33.9385Z"
          stroke="#009045"
          strokeWidth="1.97337"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M61.9141 49.793H73.1564V38.7195H61.9141V49.793Z"
          fill="white"
          stroke="#009045"
          strokeWidth="1.97337"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.7969 33.9385H90.0391V22.8649H78.7969V33.9385Z"
          stroke="#009045"
          strokeWidth="1.97337"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M84.5176 60.24C91.9703 60.24 98.0118 54.2891 98.0118 46.9484C98.0118 39.6076 91.9703 33.6567 84.5176 33.6567C77.065 33.6567 71.0234 39.6076 71.0234 46.9484C71.0234 54.2891 77.065 60.24 84.5176 60.24Z"
        fill="#B0EF8F"
      />
      <path
        d="M85.0154 56.358L74.7344 45.4295L77.6234 40.7865L84.9677 46.5993L98.2023 31.0732L103.657 36.7685L85.0154 56.358Z"
        fill="#009045"
      />
    </g>
    <defs>
      <clipPath id="clip0_11852_27643">
        <rect
          width="65"
          height="64.0244"
          fill="white"
          transform="translate(38.1328)"
        />
      </clipPath>
    </defs>
  </svg>
);
